import React from 'react';

import StarsIcon from '../../assets/stars.svg';
import BaseLauncher from '../BaseLauncher';
import LauncherButton from '../LauncherButton';

interface Props {
    onLaunch?: () => void;
    className?: string;
}

const AuthorizedPaidView: React.FC<Props> = ({ className, onLaunch }) => {
    return (
        <BaseLauncher
            title={
                <>
                    {'Introducing'}
                    &nbsp;
                    <strong>{'AI Insights.'}</strong>
                    &nbsp;
                    {'instantly decode any CVE'}
                </>
            }
            description={'Leverage the power of AI to quickly understand vulnerabilities, impacts, and exploitability'}
            action={
                <LauncherButton startIcon={<StarsIcon />} onClick={onLaunch}>
                    {'Get AI Insights for that CVE'}
                </LauncherButton>
            }
            className={className}
        />
    );
};

export default AuthorizedPaidView;
